export default "__VITE_ASSET__BjuBTZiH__"